import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';

class SuggesterItem extends Component{
    constructor(props){
        super(props);
        this.itemClk = this.itemClk.bind(this);
    }
    itemClk(e){
        e.preventDefault();
        e.stopPropagation();
        let {onClick, data} = this.props;
        onClick && onClick(data.nickname);
    }
    render(){
        let {data} = this.props;
        return (
            <li className="atls_item" onClick={this.itemClk}>{data.nickname}</li>
        )
    }
}
class Suggester extends Component{
    constructor(props) {
        super(props);
        this.state = {};
        this.stop = this.stop.bind(this);
    }
    stop(e){
        e.preventDefault();
        e.stopPropagation();
    }
    getRootDom(){
        return ReactDom.findDOMNode(this);
    }
    render(){
        let {list, offset, onClick} = this.props;
        list = list || [];
        let ostyle;
        //console.log(offset);
        if(offset){
            ostyle = {};
            for(let p in offset){
                if(p == 'x'){
                    ostyle['left'] = offset[p] + 'px';
                }
                else if(p == 'y'){
                    ostyle['top'] = offset[p] + 'px';
                }
            }
        }
        return (
            <div className="u-at_list" style={ostyle} onClick={this.stop}>
                <p className="atls_tl">{list.length > 0 ? '选择最近@的人或直接输入' : '轻敲空格完成输入'}</p>
                <ul>
                    {
                        list.map((item, n) => {
                            return (<SuggesterItem onClick={onClick} key={"sugg_" + n} data={item} />)
                        })
                    }
                </ul>
            </div>
        )
    }
}

export default Suggester;


// WEBPACK FOOTER //
// ./client/component/at/suggest.js